// Reusable navigation item component with submenu support
import type { MenuItem, SubMenuItem } from '@/config/headerMenu';
import type { PortalLinks } from '@/config/portalLinks';

import { useTranslation } from 'react-i18next';

interface NavItemProps {
  item: MenuItem;
  portalLinks: PortalLinks;
  isOverseas: boolean;
  filteredSubItems: SubMenuItem[];
}

export const NavItem = ({ item, portalLinks, isOverseas, filteredSubItems }: NavItemProps) => {
  const { t, i18n } = useTranslation();
  const hasSubMenu = filteredSubItems.length > 0;
  const mainLink = item.getLink(portalLinks, isOverseas, i18n.language);
  const isLiveDemo = item.id === 'liveDemo';
  const label = isOverseas && item.labelOverseasKey ? t(item.labelOverseasKey) : item.label;

  return (
    <div className='gnb-item relative xl:shrink-0 xl:px-5 2xl:px-10'>
      <a
        href={mainLink}
        className={`gnb-title block cursor-pointer text-[14px] font-medium transition-colors duration-200 group-[.header-white]:text-black xl:whitespace-nowrap xl:text-center xl:text-[18px] xl:leading-[104px] ${isLiveDemo ? 'xl:text-[#1465F4] group-[.header-white]:xl:text-[#1465F4]' : 'xl:text-white'} 2xl:text-[20px]`}
      >
        {label}
      </a>

      {hasSubMenu && (
        <div className='sub-gnb-wrap absolute top-26 left-1/2 hidden max-h-0 w-max min-w-[120px] -translate-x-1/2 overflow-hidden bg-white px-6 text-center shadow-md transition-[max-height] duration-400 ease-in-out after:absolute after:top-0 after:left-1/2 after:h-[2px] after:w-0 after:-translate-x-1/2 after:bg-[#1465F4] after:transition-all after:duration-300 after:content-[""] xl:block [&.open]:max-h-[400px] [&.open]:after:w-full'>
          {filteredSubItems.map((subItem, index) => {
            const subLink = subItem.getLink(portalLinks, isOverseas, i18n.language);
            const label =
              isOverseas && subItem.labelOverseasKey ? t(subItem.labelOverseasKey) : t(subItem.labelKey);

            return (
              <div key={`${item.id}-sub-${index}`} className='sub-gnb-item'>
                <a
                  href={subLink}
                  className='sub-gnb-title flex min-h-[40px] flex-col items-center justify-center py-2 text-[17px] leading-[1.2] font-medium whitespace-nowrap transition-colors duration-200 hover:text-[#1465F4]'
                >
                  {label}
                </a>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
